import { Grid, Typography } from "@material-ui/core";
import CustomDateField from "components/CustomDateField";
import SanitizedGrid from "components/SanitizedGrid";
import React from "react";
import {
  Datagrid,
  TextField,
  FunctionField,
  ResourceContextProvider,
  Filter,
  SearchInput,
  ShowProps,
} from "react-admin";
import { GridinRow, GridLabel } from "utils/style";
import { StudentResources } from "utils/tools";
import { StyledList } from "../../components/ListWrapper";
import CustomPagination from "../../components/CustomPagination";

const ThisFilter = (props: any) => (
  <Filter {...props}>
    <SearchInput source="search" alwaysOn />
  </Filter>
);

const Sibling = (props: ShowProps) => {
  const StudentResource = StudentResources(Number(props.id));
  return (
    <SanitizedGrid container spacing={2}>
      <Grid item xs={12}>
        <Typography variant="h6">Siblings</Typography>
      </Grid>
      <Grid item xs={12}>
        <ResourceContextProvider value="students">
          <StyledList
            {...props}
            exporter={false}
            hasCreate={false}
            filters={<ThisFilter />}
            filterDefaultValues={{
              ParentId: Number(StudentResource.parent?.id),
            }}
            bulkActionButtons={false}
            title=" "
            pagination={<CustomPagination />}
          >
            <Datagrid rowClick="show">
              <FunctionField
                label="Sibling"
                render={() => (
                  <SanitizedGrid container spacing={2}>
                    <Grid item xs={12} style={GridinRow}>
                      <Typography variant="body2" style={GridLabel}>
                        Id :
                      </Typography>
                      <TextField source="id" emptyText="-" />
                    </Grid>

                    <Grid item xs={12} style={GridinRow}>
                      <Typography variant="body2" style={GridLabel}>
                        Name :
                      </Typography>
                      <FunctionField
                        render={(record: any) =>
                          `${record.firstName} ${record.lastName}`
                        }
                        emptyText="-"
                      />
                    </Grid>

                    <Grid item xs={12} style={GridinRow}>
                      <Typography variant="body2" style={GridLabel}>
                        Gender :
                      </Typography>
                      <TextField source="gender" emptyText="-" />
                    </Grid>

                    <Grid item xs={12} style={GridinRow}>
                      <Typography variant="body2" style={GridLabel}>
                        Birthday :
                      </Typography>
                      <CustomDateField source="dateOfBirth" emptyText="-" />
                    </Grid>
                  </SanitizedGrid>
                )}
              />
              {/* <TextField source="Major" />
              <TextField source="Minor" /> */}
              <CustomDateField
                source="createdAt"
                label="Date Registered"
                emptyText="-"
                isDateTime
              />
            </Datagrid>
          </StyledList>
        </ResourceContextProvider>
      </Grid>
    </SanitizedGrid>
  );
};

export default Sibling;
